<template>
  <div>
    <div class="router-header flex flex-wrap items-center mb-3 mb-base">
      <div
        class="content-area__heading pr-4"
      >
        <div class="mt-2 mb-1">
          <span style="font-size: 25px;">Do you feel motivated to continue developing this attribute?</span>
        </div>
      </div>
    </div>

    <Result
      v-if="submit === true"
      :progress="prog"
      :practice="prac"
      :relevancy="rel"
    />
    <div class="text-center">
      <div class="mb-base">
        <vs-button size="large" color="primary" @click="progress(0)"
        >Going Great</vs-button
        >
      </div>
      <div class="mb-base">
        <vs-button size="large" color="danger" @click="progress(2)"
        >Not So Good</vs-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import Result from './Result'
export default {
  name: "QuestionZero",
  components: {Result},
  props: ["q"],
  data() {
    return {
      answerOne: null,
    };
  },
  methods: {
    progress(i) {
      let value = 100;
      if (i === 0) value = 100;
      else if (i === 1) value = 50;
      else if (i === 2) value = 0;
      else if (i === 3) value = 25;
      const progressObj = {
        q: -1,
        value
      };
      this.$store
        .dispatch("competencyProgress/calculate", progressObj)
        .then(res => {
          console.log("progress calculate", res);
          console.log(this.$store.state.competencyProgress);
        })
        .catch(err => {
          console.log("error progress calculate", err);
        });
    }
  }
};
</script>

<style scoped>
.borderWhite2 {
  border: 2px solid white;
}

.borderPrimary2 {
  border-color: #9dcd5b;
}

.vx-card .vx-card__collapsible-content {
  -webkit-transition: none !important;
  transition: none !important;
}

.selectedAnswer {
  background: #9dcd5b! important;
  color: white! important;
}

.btn-group > button {
  width: 25% !important;
  font-size: 0.8rem !important;
}
</style>
